<div class="sub-nav">
  <app-h5 [noMargin]="true" [ink]="'ink-70'" class="sub-nav-parent-title" *ngIf="parentTitle">{{ parentTitle }}</app-h5>
  <ng-container *ngFor="let group of groups; let i = index">
    <div *ngIf="group.title">
      <div *ngIf="isCollapsable(group); else staticTitle" class="sub-nav-action collapsable" (click)="toggleGroup(i)" (keydown.enter)="toggleGroup(i)" (keydown.space)="toggleGroup(i)" tabindex="0" role="button">
        <app-body-md>{{ group.title }}</app-body-md>
        <app-icon 
          class="expand-arrow"
          [ngClass]="{'expanded': isGroupExpanded(i, group)}"
          [size]="'small'"
          [color]="'primary-action'">expand_more</app-icon>
      </div>
      <ng-template #staticTitle>
        <app-h5 [noMargin]="true" [ink]="'ink-70'" class="sub-nav-group-title">{{ group.title }}</app-h5>
      </ng-template>
    </div>
    <div 
      class="sub-nav-item-children"  
      [style.maxHeight.px]="isGroupBodyVisible(i, group) ? calculateRowHeight(group) : 0" 
    >
      <div *ngFor="let action of group.items; let j = index" class="sub-nav-item">
        <app-a
          *ngIf="action.routerLink"
          class="sub-nav-route-link"
          [tid]="convertTitleToTestId(action.title)"
          [routeTo]="action.routerLink"
          [bold]="false"
          [class.active]="isRouteActive(action.routerLink, (currentUrl$ | async) || '')"
        >
          <app-icon
            class="me-2"
            *ngIf="action.icon !== ''"
            [size]="'small'"
            [color]="'primary-action'"
            [outlined]="true"
            [useSymbol]="true"
            >{{ action.icon }}</app-icon>
          <app-body-md>{{ action.title }}</app-body-md>
        </app-a>
        <div
          *ngIf="!action.routerLink"
          class="sub-nav-action"
          [tid]="convertTitleToTestId(action.title)"
          [class.active]="isRouteActive(action.routerLink, (currentUrl$ | async) || '')"
          (click)="parentClick(action)"
          (keydown.enter)="parentClick(action)"
          (keydown.space)="parentClick(action)"
          tabindex="0"
          role="button"
        >
          <app-icon
            class="me-2"
            *ngIf="action.icon !== ''"
            [size]="'small'"
            [color]="'primary-action'"
            [outlined]="true"
            [useSymbol]="true"
            >{{ action.icon }}</app-icon>
          <app-body-md>{{ action.title }}</app-body-md>
        </div>
      </div>
    </div>
    <hr *ngIf="group.insertHr" />
  </ng-container>
</div>
